// generated by srcset-codegen
import src from "./lockup-neon.svg";

const width = 1733;
const height = 283;
export default { src, width, height };
